import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    logo: {
        width: "200px"
    }
}));

const Logo = ({ className }) => {
    const classes = useStyles()

    return <img className={clsx(classes.logo, className)} src="/logo.png" alt="logo" />
}

export default Logo